import { getFunctions, httpsCallable } from 'firebase/functions';

const FN_NAME = 'generateAgentPublicQr';
const FN_ALL = 'generateAllAgentsPublicQr';

/**
 * Genera o regenera el QR público de un agente (/agentes#agente-:id).
 * @param {string} agenteId
 * @param {{ regenerateQrOnly?: boolean, logoPosition?: 'center-logo' | 'corner-logo' }} [opts]
 */
export async function generateOrRegenerateAgentPublicQr(agenteId, { regenerateQrOnly = false, logoPosition } = {}) {
  if (!agenteId || typeof agenteId !== 'string') {
    throw new Error('agenteId es obligatorio');
  }
  const fn = httpsCallable(getFunctions(), FN_NAME);
  const payload = { agenteId, regenerateQrOnly };
  if (logoPosition === 'corner-logo' || logoPosition === 'center-logo') {
    payload.logoPosition = logoPosition;
  }
  const resp = await fn(payload);
  return resp?.data || null;
}

/**
 * Genera (o regenera) QR para todos los agentes publicados en /agentes (agentes_publicos).
 * @param {{ regenerate?: boolean, logoPosition?: 'center-logo' | 'corner-logo' }} [opts]
 */
export async function generateAllAgentsPublicQr({ regenerate = false, logoPosition } = {}) {
  const fn = httpsCallable(getFunctions(), FN_ALL);
  const payload = { regenerate };
  if (logoPosition === 'corner-logo' || logoPosition === 'center-logo') {
    payload.logoPosition = logoPosition;
  }
  const resp = await fn(payload);
  return resp?.data || null;
}

